const TIPOS_PERFIL = {
    ADMINISTRADOR: 'ADMINISTRADOR',
    OPERADOR: 'OPERADOR',
    SUPERVISOR: 'SUPERVISOR',
    PROFESSOR: 'PROFESSOR'
};

const PERFIL_IDS = {
    ADMINISTRADOR: 1,
    OPERADOR: 2,
    SUPERVISOR: 5
};

export class PerfilService {
    constructor() {
        this.perfilAtual = this.obterTipoPerfil;
    }

    get usuario() {
        return localStorage.getItem('usuario');
    }

    get obterTipoPerfil() {
        const tipoPerfil = localStorage.getItem('tipo');
        const perfilId = parseInt(tipoPerfil !== null ? tipoPerfil : 0);

        if (perfilId === PERFIL_IDS.ADMINISTRADOR) {
            return TIPOS_PERFIL.ADMINISTRADOR;
        }

        if (perfilId === PERFIL_IDS.OPERADOR) {
            return TIPOS_PERFIL.OPERADOR;
        }

        if (perfilId === PERFIL_IDS.SUPERVISOR) {
            return TIPOS_PERFIL.SUPERVISOR;
        }

        return TIPOS_PERFIL.PROFESSOR;
    }

    get ehAdministrador() {
        return this.perfilAtual === TIPOS_PERFIL.ADMINISTRADOR;
    }

    get ehOperador() {
        return this.perfilAtual === TIPOS_PERFIL.OPERADOR;
    }

    get ehProfessor() {
        return this.perfilAtual === TIPOS_PERFIL.PROFESSOR;
    }

    get ehSupervisor() {
        return this.perfilAtual === TIPOS_PERFIL.SUPERVISOR;
    }

    get ehAdministradorOuOperador() {
        return this.ehAdministrador || this.ehOperador;
    }

    get ehAdminOuSupervisor() {
        return this.ehAdministrador || this.ehSupervisor;
    }

    get ehAdminSupervisorOuOperador() {
        return this.ehAdministrador || this.ehSupervisor || this.ehOperador;
    }
}

export { TIPOS_PERFIL, PERFIL_IDS };
